import { api } from '@connected/api-client';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { queryClient } from '@/lib/query-client';

export const Route = createFileRoute(
    '/_auth/dashboard/',
)({
    component: RouteComponent,
    beforeLoad: async () => {
        const organizations = await queryClient.fetchQuery(api.queryOptions('get', '/api/v2/organizations/list', {
            params: {
                query: {
                    PageNumber: 1,
                    PageSize: 100,
                    Select: {
                        Name: true,
                        Description: true,
                        ElectricalOrganizationKind: true,
                        LogoOrganizationFileId: true,
                        ChamberOfCommerceNumber: true,
                        LegalPersonKind: true,
                    },
                    Sort: ['Name'],
                },
            },
        }));

        if (organizations.Organizations?.length === 1) {
            throw redirect({
                to: '/dashboard/organizations/$organizationId',
                params: {
                    organizationId: organizations.Organizations[0].OrganizationId,
                },
            });
        }
        else {
            throw redirect({ to: '/dashboard/organizations' });
        }
    },
});

function RouteComponent() {
    return null;
}
